export const oneinchArbitrumProtocols = [
    'ARBITRUM_BALANCER_V2',
    'ARBITRUM_ONE_INCH_LIMIT_ORDER',
    'ARBITRUM_ONE_INCH_LIMIT_ORDER_V2',
    'ARBITRUM_ONE_INCH_LIMIT_ORDER_V3',
    'ARBITRUM_DODO',
    'ARBITRUM_DODO_V2',
    'ARBITRUM_SUSHISWAP',
    'ARBITRUM_DXSWAP',
    'ARBITRUM_UNISWAP_V3',
    'ARBITRUM_CURVE',
    'ARBITRUM_CURVE_V2',
    'ARBITRUM_GMX',
    'ARBITRUM_SYNAPSE',
    'ARBITRUM_SADDLE',
    'ARBITRUM_KYBERSWAP_ELASTIC',
    'ARBITRUM_KYBER_DMM_STATIC',
    'ARBITRUM_AAVE_V3',
    'ARBITRUM_ELK',
    'ARBITRUM_WOOFI_V2',
    'ARBITRUM_CAMELOT',
    'ARBITRUM_TRADERJOE',
    'ARBITRUM_TRADERJOE_V2',
    'ARBITRUM_SWAPFISH',
    'ARBITRUM_PMM6',
    'ARBITRUM_ZYBER',
    'ARBITRUM_ZYBER_STABLE',
    'ARBITRUM_SOLIDLIZARD',
    'ARBITRUM_ZYBER_V3',
    'ARBITRUM_MYCELIUM',
    'ARBITRUM_TRIDENT',
    'ARBITRUM_SHELL_OCEAN',
    'ARBITRUM_RAMSES',
    'ARBITRUM_TRADERJOE_V2_1'
] as const;
